import AspectRatio from "react-aspect-ratio";
import "react-aspect-ratio/aspect-ratio.css";

export default AspectRatio;
